import {Component} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ConnectorListComponent} from './connector-list/connector-list.component';
import {NgIf} from '@angular/common';
import {MatMenuModule} from '@angular/material/menu';

@Component({
  selector: 'app-connector-shape',
  templateUrl: './connector-shape.component.html',
  styleUrls: ['./connector-shape.component.scss'],
  animations: [
    trigger('highlightAnimTrigger', [
      state(
        'active',
        style({
          backgroundColor: 'rgba(47, 228, 111, 0.8)'
        })
      ),
      state(
        'inactive, void',
        style({
          backgroundColor: 'rgba(47, 228, 111, 0)'
        })
      ),
      transition('active => inactive', animate(6000)),
      transition('inactive => active', animate('500ms cubic-bezier(0.230, 1.000, 0.320, 1.000)'))
    ])
  ],
  standalone: true,
  imports: [MatMenuModule, NgIf, ConnectorListComponent]
})
export class ConnectorShapeComponent {
  public highlightState: 'active' | 'inactive';
  public mxKey: number | string;
  protected menuState: boolean;

  constructor() {}

  public highlight() {
    this.highlightState = 'active';
  }

  public highlightDone() {
    this.highlightState = 'inactive';
  }

  public highlightStart() {}
}
